import React from "react";
import { connect } from "react-redux";
import ViftoLogo from "./assets/vifto-logo-small.svg";
import { Actions as VIFTOACTIONS } from "./store/viftoActions";
import { useMemo } from "react";
import { CheckCircleIcon } from "@heroicons/react/20/solid";

const SendDataToVifto = ({ periodId, sending, sendPayPeriodToVifto, sentToAccountingIntegration }) => {
	const status = useMemo(() => {
		if (sentToAccountingIntegration)
			return <CheckCircleIcon style={{ color: "green", width: 15, position: "relative", top: -8, right: -14 }} />;

		return null;
	}, [sentToAccountingIntegration]);

	if (!status) return null;

	return (
		<div
			title="Send Data To Vifto"
			className="js-send-to-xero"
			type="button"
			style={{
				height: "1.5em",
				width: "1.5em",
				borderRadius: "50%",
				position: "relative",
				cursor: "pointer",
				marginLeft: 10,
			}}
			onClick={() => {
				if (!sending) sendPayPeriodToVifto(periodId);
			}}
		>
			<img
				src={ViftoLogo}
				style={{ width: 24.5 }}
			/>
			{status}
		</div>
	);
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({
	sendPayPeriodToVifto: (payPeriodId) => dispatch(VIFTOACTIONS.sendPayPeriodToVifto(payPeriodId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SendDataToVifto);
